import React from 'react';
import PropTypes from 'prop-types';
import { Form } from './Form';
import T from 'i18n-react';

const GuardianFormStage = ({
  data,
  allCountries,
  onSubmit,
  onPrevStage,
  progressBar,
  paxDisplayName,
}) => (
  <div>
    <div className="container">
      <h1 className="container__header">
        {`${T.translate('legalGuardianInformation')} ${paxDisplayName}`}
      </h1>
      <Form
        validateGuardian
        user={data}
        allCountries={allCountries}
        onSubmit={onSubmit}
        onPrevStage={onPrevStage}
      />
    </div>
    {progressBar}
  </div>
);

GuardianFormStage.propTypes = {
  data: PropTypes.object.isRequired,
  allCountries: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  onPrevStage: PropTypes.func.isRequired,
  progressBar: PropTypes.element.isRequired,
  paxDisplayName: PropTypes.string,
};

export default GuardianFormStage;



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/GuardianFormStage.js